"use client";

import dynamic from "next/dynamic";

const CookieConsent = dynamic(() => import("@/components/CookieConsent"), { ssr: false });
/*
 * Server-rendered, unlike its neighbours. The resting Ask-Bar is the first
 * thing on the home page, and behind `ssr: false` it could not paint until the
 * bundle had loaded and hydrated — a second on a fast machine, nearly four on a
 * throttled one, with an empty reserved gap in the meantime. It positions its
 * resting appearance from CSS so the server's markup lands in the right place
 * with no measurement; see AssistantHost.
 */
const AssistantHost = dynamic(
  () => import("@/components/AIAssistant/AssistantHost")
);
const SentryInitializer = dynamic(() => import("@/components/SentryInitializer"), { ssr: false });

export default function ClientOverlays({
  recordRetentionDays,
}: {
  recordRetentionDays: number;
}) {
  return (
    <>
      <CookieConsent />
      {/*
        The one and only assistant. It renders itself in whichever appearance
        the conversation provider reports — resting over the home page's
        reservation slot, docked in the corner, or collapsed to a bubble — and
        nothing at all when the chat provider is unconfigured.
      */}
      <AssistantHost recordRetentionDays={recordRetentionDays} />
      <SentryInitializer />
    </>
  );
}
